import React from "react";

import ContentArrayLinks, { type LinkRow } from "../UpdatePage/ContentArrayLinks";

export type ArrayLinksProps = {
    required?: boolean;
    variableName: string;
    handleLinkArray: (links: LinkRow[], variableName: string) => void;
};

/**
 * The create wizard's Array:links editor (SCRUM-2195): the update screens'
 * ContentArrayLinks with the wizard's differences set, not a second copy.
 * - Start rows: one empty row when required, none when optional. `key` makes a
 *   `required` flip (a template switch) start over (SCRUM-2178).
 * - The last row cannot be deleted in either column (SCRUM-1405).
 * - Rows are uncontrolled, and there are no sub-links (SCRUM-2171 is update-only).
 * - add, delete and every edit report `handleLinkArray(links, variableName)`.
 */
function ArrayLinks({ required, variableName, handleLinkArray }: ArrayLinksProps) {
    const report = (links: LinkRow[]) => handleLinkArray(links, variableName);
    return (
        <ContentArrayLinks
            key={String(required)}
            variableName={{ variable: variableName, value: required ? [{ index: 1, name: "", link: "" }] : [] }}
            isRequired
            controlled={false}
            subLinks={false}
            handleLinkArray={report}
            add={report}
            delete={report}
        />
    );
}

export default ArrayLinks;
